import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectIsSuperUser } from '../state/selectors';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  isSuperUser$ = this.store.select(selectIsSuperUser);

  constructor(private store: Store) {}
}
